import {Context, ContextUtil} from './context';
import Utils from "../utils";

export default class CiblerAPI {
  static checkEligibility = (disableMultidisplay, callback) => {
    let url = `${Context.endpoint}/api/campaigns/eligibility/?customerId=${Context.customerId}`;

    if (Context.trigger) url = `${url}&trigger=${Context.trigger}`;
    if (Context.userGroup) url = `${url}&userGroupId=${Context.userGroup}`;
    if (Context.behaviorUUID) url = `${url}&behaviorUUID=${Context.behaviorUUID}`;
    if (Context.ciblerCampaign) url = `${url}&noReference=${Context.ciblerCampaign}`;
    if (Context.userUUID) url = `${url}&userUUID=${Context.userUUID}`;
    if (Context.testMode) url = `${url}&testMode=${Context.testMode}`;
    if (Context.debugMode) url = `${url}&debugMode=${Context.debugMode}`;
    if (Context.currentPrize) url = `${url}&current=${Context.currentPrize}`;
    if (Context.campaignTracking) url = `${url}&refused=${Context.campaignTracking}`;
    if (disableMultidisplay) url = `${url}&disableMultidisplay=true`;

    if (!window.WIO.navTracking) return;
    const body = { ...window.WIO.navTracking.event };
    if (!body.context) body.context = {};
    if (!body.data) body.data = {};
    body.device = body.context.device;
    body.data = JSON.stringify(body.data);
    body.context.previousVector = Utils.getVector();
    body.context = JSON.stringify(body.context);
    Utils.HttpPost(url, callback, body, window.WIO.userId);
  };

  static getTriggers = (callback) => {
    const result = sessionStorage.getItem('ciblerTriggerResult');
    if (result && Utils.isStringJson(result)) {
      callback(result);
      return;
    }

    Utils.getAjax(
      `${Context.cacheEndpoint}/api/campaigns/eligibility/triggers/${Context.customerId}`,
      callback,
      () => undefined,
      window.WIO.userId,
    );
  };

  static getCampaignData = (campaignId, userGroupsId, callback) => {
    let url = `${Context.cacheEndpoint}/api/campaigns/data/${campaignId}?device=${Context.device}`;
    if (userGroupsId) url = `${url}&userGroupId=${userGroupsId}`;
    Utils.getAjax(url, callback(campaignId));
  };

  static refuse = () => {
    if (!Context.behaviorUUID) return;

    Utils.putAjax(`${Context.endpoint}/api/campaignBehaviors/refuse/${Context.behaviorUUID}`, () => false);
  };

  static discoverGift = (localContext, callback) => {
    if (Context.trigger) {
      localStorage.setItem('currentPrizeDate', (new Date()).getTime());
      callback(JSON.stringify({
        code: 'fakeCode123',
        gift: { name: 'fakeName', threshold: '90', description: 'X€' },
      }));
      return;
    }
    if (localStorage.getItem('currentPrize') !== localContext.prizeUUID) {
      localStorage.setItem('currentPrize', localContext.prizeUUID);
      localStorage.setItem('currentPrizeDate', (new Date()).getTime());
    }

    if (!localContext.prizeUUID) {
      callback(JSON.stringify({
        code: 'noCode',
        gift: { name: 'noGift', threshold: '0', description: '' },
      }));
      return;
    }

    let url = `${Context.endpoint}/api/giftCodes/discover/${localContext.prizeUUID}?fp=${window.WIO.userId
    }&campaign=${localContext.campaignId}&behaviorId=${localContext.behaviorUUID}&sessionId=${localContext.sessionId}`;

    if (localContext.crossSell && localContext.crossSell.sku) {
      if (Utils.getCampaignData(localContext.campaigndata.crossProduct)) {
        url = `${url}&sku=${Utils.getCampaignData(localContext.campaigndata.crossProduct)}`;
      } else {
        url = `${url}&sku=${Context.product.product_id}`;
      }
    }

    Utils.HttpPost(url, callback);
  };

  static sendSponsort = (emailList) => {
    const data = {
      senderMail: Context.customer.email,
      emailList,
    };

    Utils.HttpPost(
      `${Context.endpoint}/api/campaignBehaviors/sponsort/${Context.campaignId}`,
      () => {
        console.log('OK');
      },
      data,
    );
  };

  static sendPriceToMail = (state) => {
    const data = {
      device: 'desktop',
      externalAuthId: null,
      externalAuthProvider: null,
      externalAuthToken: null,
      fp: window.WIO.userId,
      redirect: '',
      sessionId: window.WIO.sessionId,
      userData: {
        cid: '',
        civility: 'F',
        data: '',
        email: state.mail,
        facebookID: '',
        firstName: '',
        guid: null,
        lastName: '',
        optIn: state.optin,
        optInPartner: false,
        parrainageId: null,
        phone: '',
        sex: '',
        sponsortEmail: null,
        token: '',
      },
    };

    Utils.HttpPost(
      `${Context.endpoint}/api/campaignBehaviors/lightLogin/${Context.campaignId}`,
      () => {
        this.discoverGift(() => {
          document.getElementById('WioGameBG').remove();
        });
      },
      data,
    );
  };

  static getLastCart = () => (
    new Promise((resolve) => {
      if (Context.lastCart) {
        resolve(Context.lastCart);
        return;
      }

      let userId = window.WIO.getSessionInfo().context.customer
        ? window.WIO.getSessionInfo().context.customer.customer_reference
        : null;

      if (Context.triggerLastCart) userId = 111605;

      const response = Utils.getAjax(
        `${Context.endpoint}/api/campaignBehaviors/order/${Context.customerId}/${userId}?interval=10`,
        (result) => {
          if (!result || !Utils.isStringJson(result)) {
            resolve(false);
            return;
          }

          const cart = JSON.parse(result);

          this.getOneAvailableProductFromList(cart.orderLines)
            .then((prod) => {
              if (!prod) {
                resolve(false);
                return;
              }
              cart.product = prod;
              ContextUtil.update('lastCart', cart);
              resolve(true);
            });
        },
        () => resolve(false),
        window.WIO.userId,
      );
      ContextUtil.update('lastCart', response);
    })
  );

  static getProductInfo = (sku, resolve) => {
    Utils.HttpPost(
      `${document.location.protocol}//${document.location.hostname}/?fc=module&module=cibler&controller=ProductInfo`,
      (result) => {
        const json = JSON.parse(result);
        if (json.return && json.return.name) {
          resolve(json.return);
          return;
        }
        resolve('');
      },
      {
        apikey: window.WIO.customerKey,
        productId: sku,
      },
    );
  };

  static getCiblerProductInfo = (sku, resolve) => {
    const url = `${Context.endpoint}/api/categories/public/${sku}?customer=${Context.customerId}`;

    Utils.getAjax(url, (result) => {
      if (!result || !Utils.isStringJson(result)) {
        resolve(false);
        return;
      }

      let product = JSON.parse(result);

      const value = {
        id: product.externalId,
        sku: product.id,
        url: product.datas.url,
        name: product.name,
        price: 0,
        stock: 1,
        category: 0,
        imageUrl: product.datas.imgUrl,
      };

      resolve(value);
    });
  }

  static getOneAvailableProductFromList = skuList => (
    new Promise((resolve) => {
      let finished = 0;
      let product = null;
      const list = skuList.length > 10 ? skuList.slice(0, 10) : skuList;
      const productMethod = Context.customerId === 33 ? this.getCiblerProductInfo : this.getProductInfo;
      list.forEach(sku => productMethod(sku.productId, (prod) => {
        if (prod && prod.stock && prod.stock > 0) {
          if (product) return;

          if (prod.imageUrl && !(
            prod.imageUrl.startsWith('http') || prod.imageUrl.startsWith('//'))) prod.imageUrl = `//${prod.imageUrl}`;
          product = prod;
          resolve(prod);
        }
        finished += 1;

        if (finished === list.length) {
          if (skuList.length <= 10) {
            resolve(null);
            return;
          }

          this.getOneAvailableProductFromList(list.slice(10)).then(resolve);
        }
      }));
    })
  );

  static getSimilarProduct = props => (
    new Promise((resolve) => {
      if (Utils.getCampaignData(props.campaigndata.crossProduct)) {
        this.getOneAvailableProductFromList([{ productId: Utils.getCampaignData(props.campaigndata.crossProduct) }])
          .then((product) => {
            if (product) ContextUtil.update([props.campaignId, 'crossSell'], product);
            resolve(product);
          });
        return;
      }

      let productId = 0;
      if (window.WIO.sessionInfo.context.trigger) {
        if (!Context.product
        || !Context.product.product_id) {
          resolve(false);
          return;
        }

        productId = window.WIO.sessionInfo.context.product.product_id;
      } else if (Context.customerId !== 33) {
        const lastCartString = localStorage.getItem('ciblerLastCart');
        localStorage.setItem('ciblerLastCart', JSON.stringify(Context.cart));

        if (!lastCartString || !Context.cart || !Context.cart.total) {
          resolve(false);
          return;
        }

        const lastCart = JSON.parse(lastCartString);
        if (lastCart.total === Context.cart.total) {
          resolve(false);
          return;
        }

        const prod = Context.cart.items.find(l => !lastCart.items || !lastCart.items.length || !lastCart.items.some(p => p.product_id === l.product_id));
        if (prod) productId = prod.product_id;
      } else {
        productId = Context.cart.items.map(m => m.productId);
      }

      if (!productId) {
        resolve(false);
        return;
      }

      if (!Array.isArray(productId)) {
        const url = `${Context.endpoint}/api/customers/${Context.customerId}/similar/${productId}`;

        Utils.getAjax(
          url,
          (skuList) => {
            if (!Utils.isStringJson(skuList)) return resolve(false);
            const json = JSON.parse(skuList);
            if (!json.length) return resolve(false);
            this.getOneAvailableProductFromList(json.map(s => ({ productId: s.similarSku })))
              .then((product) => {
                if (product) ContextUtil.update([props.campaignId, 'crossSell'], product);
                resolve(product);
              });
          },
          () => resolve(false),
        );
      } else {
        this.getSimilarRecur(productId, resolve, props, 0);
      }
    })
  )

  static getSimilarRecur = (ids, resolve, props, i) => {
    if (i >= ids.length) return resolve(false);
    const url = `${Context.endpoint}/api/customers/${Context.customerId}/similar/${ids[i]}`;

    Utils.getAjax(
      url,
      (skuList) => {
        if (!Utils.isStringJson(skuList)) return this.getSimilarRecur(ids, resolve, props, i + 1);
        const json = JSON.parse(skuList);
        if (!json.length) return this.getSimilarRecur(ids, resolve, props, i + 1);
        this.getOneAvailableProductFromList(json.map(s => ({ productId: s.similarSku })))
          .then((product) => {
            if (product) ContextUtil.update([props.campaignId, 'crossSell'], product);
            resolve(product);
          });
      },
      () => this.getSimilarRecur(ids, resolve, props, i + 1),
    )
  }

  static getFormData = (campaignId, callback) => {
    Utils.getAjax(
      `${Context.endpoint}/api/campaigns/formdatas/${campaignId}`,
      (res) => {
        if (!Utils.isStringJson(res)) return;
        callback && callback(JSON.parse(res));
      }
    )
  }

  static lightLogin = (campaignId, data, callback) => {
    const userData = {
      email: "",
      firstName: "",
      lastName: "",
      phone: "",
      ...data
    }

    const body = {
      fp: "tagFP",
      userData,
      device: "desktop"
    }

    Utils.HttpPost(
      `${Context.endpoint}/api/campaignBehaviors/lightLogin/${campaignId}`,
      (res) => {
        if (!Utils.isStringJson(res)) return;
        callback && callback(JSON.parse(res));
      },
      body
    )
  }
}
